import { DateAdapter } from '@angular/material/core';
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/de';

export const AppDateRangePickerFormats = {
  parse: {
    dateInput: 'DD.MM.YYYY',
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export class AppDateRangePickerDayjsAdapter extends DateAdapter<Dayjs> {
  getYear(date: dayjs.Dayjs): number {
    return date.year();
  }
  getMonth(date: dayjs.Dayjs): number {
    return date.month();
  }
  getDate(date: dayjs.Dayjs): number {
    return date.date();
  }
  getDayOfWeek(date: dayjs.Dayjs): number {
    return date.day();
  }
  getMonthNames(style: 'long' | 'short' | 'narrow'): string[] {
    const styleMap: Record<'long' | 'short' | 'narrow', 'MMM' | 'MMMM'> = {
      long: 'MMMM',
      short: 'MMM',
      narrow: 'MMM',
    };
    return Array.from({ length: 12 }, (_, i) => dayjs().month(i).format(styleMap[style]));
  }
  getDateNames(): string[] {
    return Array.from({ length: 31 }, (_, i) => String(i + 1));
  }
  getDayOfWeekNames(style: 'long' | 'short' | 'narrow'): string[] {
    const styleMap: Record<'long' | 'short' | 'narrow', 'dd' | 'ddd' | 'dddd'> = {
      long: 'dddd',
      short: 'ddd',
      narrow: 'dd',
    };
    return Array.from({ length: 7 }, (_, i) => dayjs().day(i).format(styleMap[style]));
  }
  getYearName(date: dayjs.Dayjs): string {
    return date.format('YYYY');
  }
  getFirstDayOfWeek(): number {
    // Hard-coded to have Sunday be the first day of the week (default)
    return 0;
  }
  getNumDaysInMonth(date: dayjs.Dayjs): number {
    return date.daysInMonth();
  }
  clone(date: dayjs.Dayjs): dayjs.Dayjs {
    return date.clone();
  }
  createDate(year: number, month: number, date: number): dayjs.Dayjs {
    const d = dayjs().set('year', year).set('month', month).set('date', date);
    if (!d.isValid()) {
      throw new Error('Invalid date');
    }
    return d;
  }
  today(): dayjs.Dayjs {
    return dayjs();
  }
  parse(value: any, parseFormat: any): dayjs.Dayjs | null {
    if (!value) return null;
    const d = dayjs(value, parseFormat);
    return d.isValid() ? d : null;
  }
  format(date: dayjs.Dayjs, displayFormat: any): string {
    return date.format(displayFormat);
  }
  addCalendarYears(date: dayjs.Dayjs, years: number): dayjs.Dayjs {
    return date.add(years, 'year');
  }
  addCalendarMonths(date: dayjs.Dayjs, months: number): dayjs.Dayjs {
    return date.add(months, 'month');
  }
  addCalendarDays(date: dayjs.Dayjs, days: number): dayjs.Dayjs {
    return date.add(days, 'day');
  }
  toIso8601(date: dayjs.Dayjs): string {
    return date.toISOString();
  }
  isDateInstance(obj: any): boolean {
    return dayjs.isDayjs(obj);
  }
  isValid(date: dayjs.Dayjs): boolean {
    return date.isValid();
  }
  invalid(): dayjs.Dayjs {
    return dayjs(NaN);
  }
}
